import type { Sort } from "@lxc/app-device-common/src/types";
import { SortOrder } from "@lxc/app-device-common/src/types";

/**
 * Composable used to manage sorting and build the sort query string
 * @param defaultSort Sort
 */
export function useSort(defaultSort?: Sort) {
  const sort: Ref<string | undefined> = ref(formatSort(defaultSort));

  /**
   * Format a sort string from a sort definition
   * @param sortDefinition Sort
   */
  function formatSort(sortDefinition?: Sort) {
    let sortFormatted = undefined;

    /**
     * If the sort definition property is not defined, use the default one
     */
    if (!sortDefinition?.prop) {
      sortDefinition = defaultSort;
    }

    if (sortDefinition?.prop) {
      switch (sortDefinition.order) {
        case SortOrder.DESC:
          sortFormatted = `-${sortDefinition.prop}`;
          break;
        case SortOrder.ASC:
          sortFormatted = `+${sortDefinition.prop}`;
          break;
      }
    }

    return sortFormatted;
  }

  /**
   * Callback on sort changed => build & update the query sort value
   * @param event Sort
   */
  function onSortChange(event: Sort) {
    sort.value = formatSort(event);
  }

  return {
    sort,
    onSortChange,
  };
}
